export const ROUTES = {
  LOGIN: '/login',
  CONTACT: '#contact',
  LOGIN_CALLBACK: '/loginCallback',
  REGISTER: '/register',
  //Private
  HOME: '/home',
  LAUGH_LOSS: '/laugh-loss',
  BAITY_CONSULTORIO: '/baity-consultorio',
  REDDIT: '/reddit',
  BINGO: '/bingo',
  BINGO_UNIQUE: '/bingo-unique',
  BINGO_UNIQUE_PLAY: '/bingo-unique-play/:id',
  //Public
  ROOT: '/',
  BINGO_PLAY: '/bingoPlay/:id',
}
